import HowToHeader from '../HowToHeader';
import HowToStep from '../HowToStep';

// Images
import step2Img from './Step 2 Image.png';
import step3Img from './Step 3 Image.png';
import step4Img from './Step 4 Image.png';
import step5Img from './Step 5 Image.png';
import step6Img from './Step 6 Image.png';

// Header
const headerText = `Creating an Account`;
const subtitleText = `You will now be required to create an account as part of the shared housing registration process.
                      The steps below will guide you through the pages you will see and when and where to click and
                      add information. Also be sure to note the specifics for entering registation credentials and
                      choosing a password as well as your security questions and answers.`;

// Steps
const step1Text = `Go to the Shared Housing Registration Portal`;
const step2Text = `Click “Log In” at the top right of the screen.`;
const step3Text = `Click “create an account”`;
const step4Text = `Fill out “Create an account” screen – please note the
                  following conditions before completing this process.`;
const step4List = [
  `Email, first name, and last name cannot be changed from whatever is provided during this
   step of the account process.`,
  `We will be contacting you directly using the email entered, so be sure to use an account you
  check regularly.`,
  `This information needs to match the information that is on your other City of Chicago Small
   Business Center account - accounts that do no match cannot be added after your account is
   created.`,
  `Password must be 8-20 digits and contain at least one upper-case letter, one lower-case
   letter, one number, and one of the following characters: @#$%. It cannot contain any other
   special characters.`,
  `When choosing your Security Questions, note that you will need to know all answers
   verbatim to change your password in the future. This includes characters used and is also
   CASE SENSITIVE. We recommend taking and saving a screen shot for future reference.`,
];
const step5Text = `Click “Create Account”.`;
const step6Text = `Verify your account by going into your email and clicking “Confirm Account” on the message
                   received regarding the Shared Housing Registration Portal.`;
const step7Text = `Double check that your account has been verified by logging in using the credentials you
                  provided while completing the sign-up process.`;

const CreateAnAccount = () => {
  return (
    <>
      <HowToHeader titleText={headerText} subtitleText={subtitleText} />
      <HowToStep stepNumber={1} content={step1Text} />
      <HowToStep stepNumber={2} content={step2Text} imgSrc={step2Img} />
      <HowToStep stepNumber={3} content={step3Text} imgSrc={step3Img} />
      <HowToStep
        stepNumber={4}
        content={step4Text}
        imgSrc={step4Img}
        listContent={step4List}
      />
      <HowToStep stepNumber={5} content={step5Text} imgSrc={step5Img} />
      <HowToStep stepNumber={6} content={step6Text} imgSrc={step6Img} />
      <HowToStep stepNumber={7} content={step7Text} />
    </>
  );
};

export default CreateAnAccount;
